import { create, filter, findAll, findOne, update, getOne, resetSave } from "@/store/Crud/functions/actions";
export default {
    create,
    filter,
    findOne,
    update,
    findAll,
    getOne,
    resetSave,
};
